// components/Map/Popup.jsx
import React from "react";
import { OverlayView } from "react-google-maps";

const pane = OverlayView.OVERLAY_MOUSE_TARGET;

/**
 * Popup rendered on the map using OverlayView (no default Google arrow).
 * - anchor: "top" | "bottom" | "left" | "right"
 */
export const chooseAnchor = (map, { lat, lng }) => {
    if (!map || !map.getBounds) return "top";
    const b = map.getBounds();
    if (!b) return "top";

    const sw = b.getSouthWest();
    const ne = b.getNorthEast();

    // Fractions inside the viewport (0=bottom/left, 1=top/right)
    const y = (lat - sw.lat()) / (ne.lat() - sw.lat());
    const x = (lng - sw.lng()) / (ne.lng() - sw.lng());

    // Flip vertically if hugging top/bottom
    if (y > 0.8) return "bottom"; // near top edge → open downward
    if (y < 0.2) return "top";    // near bottom edge → open upward

    // Otherwise, if hugging left/right, use horizontal
    if (x > 0.85) return "left";
    if (x < 0.15) return "right";

    // Default
    return "top";
};

export default function MapPopup({ position, anchor = "top", onClose, children, zIndex = 200 }) {
    const getPixelPositionOffset = (width, height) => {
        // center horizontally, then nudge based on the chosen anchor
        switch (anchor) {
            case "bottom": return { x: -width / 2, y: 8 };
            case "left": return { x: -width - 8, y: -height / 2 };
            case "right": return { x: 8, y: -height / 2 };
            case "top":
            default: return { x: -width / 2, y: -height - 8 };
        }
    };

    return (
        <OverlayView
            position={position}
            mapPaneName={pane}
            getPixelPositionOffset={getPixelPositionOffset}
        >
            <div
                onMouseDown={(e) => { e.stopPropagation(); }}
                onClick={(e) => { e.stopPropagation(); }}
                onDoubleClick={(e) => { e.stopPropagation(); }}
                onWheel={(e) => { e.stopPropagation(); }}
                onTouchStart={(e) => { e.stopPropagation(); }}
                onTouchEnd={(e) => { e.stopPropagation(); }}
                className="gm-popup"
                style={{
                    position: "relative",
                    zIndex,
                    background: "#fff",
                    borderRadius: 8,
                    boxShadow: "0 8px 24px rgba(0,0,0,.15)",
                    overflow: "hidden",
                    width: 260,
                }}
                onMouseLeave={onClose}
            >
                {/* <button
                    aria-label="Close popup"
                    onClick={onClose}
                    style={{
                        position: "absolute",
                        top: 6,
                        right: 6,
                        border: "none",
                        background: "rgba(0,0,0,.06)",
                        width: 24,
                        height: 24,
                        borderRadius: 12,
                        cursor: "pointer",
                    }}
                >
                    ×
                </button> */}

                {/* optional minimal “anchor” triangle you can keep or delete */}
                <span
                    aria-hidden
                    style={{
                        position: "absolute",
                        width: 0,
                        height: 0,
                        ...(anchor === "top" && {
                            left: "50%", transform: "translateX(-50%)",
                            bottom: -8, borderLeft: "8px solid transparent",
                            borderRight: "8px solid transparent", borderTop: "8px solid #fff",
                        }),
                        ...(anchor === "bottom" && {
                            left: "50%", transform: "translateX(-50%)",
                            top: -8, borderLeft: "8px solid transparent",
                            borderRight: "8px solid transparent", borderBottom: "8px solid #fff",
                        }),
                        ...(anchor === "left" && {
                            right: -8, top: "50%", transform: "translateY(-50%)",
                            borderTop: "8px solid transparent", borderBottom: "8px solid transparent",
                            borderLeft: "8px solid #fff",
                        }),
                        ...(anchor === "right" && {
                            left: -8, top: "50%", transform: "translateY(-50%)",
                            borderTop: "8px solid transparent", borderBottom: "8px solid transparent",
                            borderRight: "8px solid #fff",
                        }),
                    }}
                />
                {children}
            </div>
        </OverlayView>
    );
}
